import React from 'react';
import cx from 'classnames';
import {Button, FormGroup, Label, Toast, Loading, Input} from "spectre-react/dist/cjs";
import {editReportPath} from "../../paths";
import {date1to2} from "../shared/utils";
import {Link} from "react-router-dom";
import {getClients, getClientsById, getReports, getSlotsHistory} from "../../selectors";
import {connect} from "react-redux";


class SlotHistoryModal extends React.PureComponent {
    static getDefaultState() {
        return {
            isOpened: false,
            slotNumber: null,
            historyItems: [],
        };
    }

    state = SlotHistoryModal.getDefaultState();

    componentDidMount() {
        this.props.provideController({open: this.open, close: this.close});
    }

    open = (slotNumber, historyItems) => {
        if (!historyItems) {
            const { reports, clientsById } = this.props;
            const { slotHistoryById } = getSlotsHistory(reports, clientsById);
            historyItems = slotHistoryById[slotNumber];
        }

        // console.log(slotNumber, historyItems);

        this.setState({isOpened: true, slotNumber, historyItems});
    };

    close = () => this.setState(SlotHistoryModal.getDefaultState());

    render() {
        const { isOpened, slotNumber, historyItems } = this.state;

        if (!isOpened)
            return null;

        return (
            <div className="modal active modal-lg">
                <span className="modal-overlay" onClick={this.close}/>
                <div className="modal-container">
                    <div className="modal-header">
                        <button type="button" className="btn btn-clear float-right" onClick={this.close}/>
                        <div className="modal-title h5">Информация про слот {slotNumber}</div>
                    </div>

                    <div className="modal-body">
                        <div id="slot-history-modal-table" className="custom-table custom-table-narrow">
                            <div className="table-row table-head">
                                <div className="table-head-cell"></div>
                                <div className="table-head-cell">Репорт</div>
                                <div className="table-head-cell">Клиент</div>
                                <div className="table-head-cell">Голова</div>
                                <div className="table-head-cell">Позиция</div>
                                <div className="table-head-cell">Снят</div>
                                <div className="table-head-cell">Установлен</div>
                            </div>

                            {historyItems.map((item, index) => (
                                <div className="table-row" key={item.slotUnmounted + item.slotMounted}>
                                    <div>{index + 1}.</div>
                                    <div>
                                        <Link to={editReportPath(item.reportId)} target="_blank">{date1to2(item.workDate)}</Link>
                                    </div>
                                    <div className="text-ellipsis" title={item.client.name}>{item.client.name}</div>
                                    <div>{item.phSerial} @ {item.phPosition}</div>
                                    <div>{item.slotPosition}</div>
                                    <div className={cx({"text-bold": slotNumber === item.slotUnmounted})}>
                                        {item.slotUnmounted}
                                    </div>
                                    <div>
                                        <span className={cx({"text-bold": slotNumber === item.slotMounted})}>
                                            {item.slotMounted}
                                        </span>
                                        {item.mountedSlotState ? <span> -- {item.mountedSlotState}</span> : null}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="modal-footer">
                        <Button link onClick={this.close}>Закрыть</Button>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {
    return {
        reports: getReports(state),
        clientsById: getClientsById(state),
    };
}

export default connect(mapStateToProps)(SlotHistoryModal);